module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1Cfz2hF/tc-custom/9781642794861.jpg?1704717815243",
      "alt": "This image is the cover for the book Power Coupling"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Power Coupling\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An experienced partnership coach takes readers on a journey from practical tools for balancing life and love to discovering their inner power and passion.")]), _c('br'), _c('br'), _vm._v(" Katherine McClelland has spent decades coaching individuals and couples toward living the lives of their dreams. Now, in "), _c('i', [_vm._v("Power Coupling")]), _vm._v(", she shares a step-by-step guide to help readers bring balance to their personal and professional lives while igniting their inner passions. These tools and ideas help readers get in touch with their true sources of power, so they can derive strength from their partnerships even in times of strain or crisis."), _c('br'), _vm._v(" Within "), _c('i', [_vm._v("Power Coupling")]), _vm._v(", readers learn: The 3 critical principles successful people use to make their efforts powerful and efficientStrategies for patient and kind communication in any role or settingHow to focus on one area of life at a time while staying connected to all the things that matter mostAnd so much more!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Katherine McClelland\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Morgan James Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0